import React, { useState, useEffect } from 'react';
import { Skeleton } from 'antd';
import { getMediaUrl } from '../utils/media';

const ImageLoader = ({ url, ht = '100%' }) => {
    const [loading, setLoading] = useState(true);
    const [imageError, setImageError] = useState(false);
    const [resolvedUrl, setResolvedUrl] = useState('');

    useEffect(() => {
        let isMounted = true;

        const resolveAndLoad = async () => {
            if (!url) {
                if (isMounted) {
                    setLoading(false);
                    setImageError(true);
                }
                return;
            }

            try {
                const finalUrl = await getMediaUrl(url);
                if (!isMounted) return;

                if (!finalUrl) {
                    setLoading(false);
                    setImageError(true);
                    return;
                }

                setResolvedUrl(finalUrl);

                const image = new Image();
                image.src = finalUrl;

                image.onload = () => {
                    if (isMounted) {
                        setLoading(false);
                        setImageError(false);
                    }
                };

                image.onerror = () => {
                    if (isMounted) {
                        setLoading(false);
                        setImageError(true);
                    }
                };
            } catch (e) {
                if (isMounted) {
                    setLoading(false);
                    setImageError(true);
                }
            }
        };

        resolveAndLoad();

        return () => {
            isMounted = false;
        };
    }, [url]);

    if (imageError) {
        return <div style={{ height: ht }} className="flex justify-center items-center text-xs text-muted-foreground">Image unavailable</div>;
    }

    return (
        <div>
            {loading ? (
                <div
                    style={{ height: ht }}
                    alt=""
                    className='flex justify-center items-center'
                >
                    <Skeleton.Image active />
                </div>
            ) : (
                <img
                    className='flex justify-center items-center w-full'
                    src={resolvedUrl}
                    alt=""
                    style={{
                        width: 'auto',
                        objectFit: 'contain'
                    }}
                />
            )}
        </div>
    );
};

export default ImageLoader;